import TenantLayout from "pages/Layout/Tenant/TenantLayout";
import React, { useEffect, useState } from "react";
import { isQldRegion } from "utils/petFormHelpers";
import Icon from "../../components/UI/Icon/Icon";
import { secureLocalStorage } from "../../utils/secureStorage";

const AgentApplicationSuccess: React.FC = () => {
  const [agentDecisionType, setAgentDecisionType] = useState<string | null>(null);
  const [landlordSigningLink, setLandlordSigningLink] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      const decisionType = await secureLocalStorage.getItem("agent_decision_type");
      const signingLink = await secureLocalStorage.getItem("landlord_signing_link");
      setAgentDecisionType(decisionType);
      setLandlordSigningLink(signingLink);
    };
    loadData();
  }, []);

  // Prevent browser back button - application already submitted
  useEffect(() => {
    const handlePopState = () => {
      // Push state back to prevent navigation
      window.history.pushState(null, "", window.location.pathname);
    };

    // Add initial history entry to prevent back navigation
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <TenantLayout roleType="agent">
      <div className="min-h-400px d-flex flex-column gap-40px align-items-center justify-content-center text-center">
        <div className="d-flex gap-30px align-items-center">
          <Icon name="dog" size={40} />
          <Icon name="cat" size={40} />
          <Icon name="bird" size={40} />
        </div>
        <div className="d-flex flex-column gap-30px">
          <div className="fs-18px fw-bold text-black">
            {
              agentDecisionType === "i_will_complete_then_request_sign" && (
                isQldRegion()
                  ? <>The application has been finalised and a copy <br /> has been saved for your records and the tenant has been notified.</>
                  : <>The application has been filled in and <br /> sent to the landlord for them to sign the document</>
              )
            }
            {
              agentDecisionType === "send_to_landlord_to_complete" && (
                isQldRegion()
                  ? <>The application has been sent to the landlord <br />for them to complete</>
                  : <>The application has been sent to the landlord <br />for them to complete and sign the document</>
              )
            }

            {
              !agentDecisionType && (
                <>This link is for an application that has already been processed.</>
              )
            }
          </div>

          {!isQldRegion() && (
          <div className="fs-16px text-grey">
            <span className="fw-bold">What happens after you sign:</span> <br />
            We will send the completed application back to you, signed by all individuals.
          </div>
          )}

          {agentDecisionType === "i_will_complete_then_request_sign" && landlordSigningLink && (
            <div className="d-flex justify-content-center">
              {landlordSigningLink}
            </div>
          )}
        </div>
      </div>
    </TenantLayout>
  );
};

export default AgentApplicationSuccess;
